import React from "react"
import MuiLink from "@material-ui/core/Link"
import { Link as GatsbyLink } from "gatsby"
import makeStyles from "@material-ui/core/styles/makeStyles"
import clsx from "../../util/clsx"

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
}))

const Link = React.forwardRef(function Link(props, ref) {
  const classes = useStyles()
  return (
    <MuiLink
      className={clsx([classes.root, props.customStyles && props.customStyles])}
      component={GatsbyLink}
      ref={ref}
      {...props}
    />
  )
})

export default Link
